import { travel } from 'api';

import { ProvinceAutoComplete, ProvinceAutoCompleteRequestResponse } from 'models/provinceAutoComplete';

// Respuesta de corp-ms-travel: Travels/GetByCityCode/{city} — no repite el código, solo
// nombres, así que el llamador arma el CityAutoComplete completo con el código que ya tenía.
export interface GetByCityCodeResponse {
  cityName: string;
  stateName: string;
  countryName: string;
}

interface GetByCityCodeRequestResponse {
  data: GetByCityCodeResponse;
}

// Búsqueda exacta por código de provincia (corp-ms-travel: Travels/GetProvinceByCode).
// A diferencia del autocomplete de búsqueda (Travels/GetProvinces), que filtra por texto
// contenido en el nombre, este endpoint matchea el ProvinceCode exacto — es el que hay que
// usar para precargar un valor ya guardado (donde solo se tiene el código, no el nombre).
export function getProvinceByCode(provinceCode: string): Promise<ProvinceAutoComplete[]> {
  return travel
    .get<ProvinceAutoCompleteRequestResponse>('Travels/GetProvinceByCode', { params: { provinceCode } })
    .then((r) => r.data.data);
}

// Búsqueda exacta por código de ciudad (corp-ms-travel: Travels/GetByCityCode/{city}). Mismo
// motivo que arriba: el autocomplete de ciudades (Travels/data/AutoComplete/Cities) también
// filtra por texto en el nombre, no por código.
export function getCityByCode(cityCode: string): Promise<GetByCityCodeResponse> {
  return travel
    .get<GetByCityCodeRequestResponse>(`Travels/GetByCityCode/${cityCode}`)
    .then((r) => r.data.data);
}
